import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "content", "active", "index", "duration"];
import React, { useContext, useState, useEffect, useRef } from 'react';
import { Accordion as SemanticUiAccordion } from 'semantic-ui-react';
import _isBoolean from 'lodash/isBoolean';
import { classNames } from '../../../../../../utils/classname';
import AnimateHeight from '../../../../../animations/components/AnimatedElement/variants/AnimateHeight';
import useSemanticUiProps from '../../../../hooks/use-semantic-ui-props';
import { ChildrenPropType } from '../../../../types/component';
import { ACCORDION_CONTENT_DISPLAY_NAME, DEFAULT_SLIDE_ANIMATION_DURATION } from '../../Accordion.constants';
import { AccordionContext } from '../../Accordion.context';
var defaultProps = {
  className: '',
  children: null,
  content: null,
  active: undefined,
  index: undefined,
  duration: DEFAULT_SLIDE_ANIMATION_DURATION
};
export default function Content(_ref) {
  var _classNames;
  var className = _ref.className,
    children = _ref.children,
    content = _ref.content,
    activeProp = _ref.active,
    index = _ref.index,
    duration = _ref.duration,
    props = _objectWithoutProperties(_ref, _excluded);
  var timeoutRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    rendered = _useState2[0],
    setRendered = _useState2[1];
  var _useContext = useContext(AccordionContext),
    activeIndexes = _useContext.activeIndexes;
  var _useSemanticUiProps = useSemanticUiProps(),
    getAccordionContentProps = _useSemanticUiProps.getAccordionContentProps;
  function isActive() {
    if (_isBoolean(activeProp)) {
      return activeProp;
    }
    return activeIndexes.includes(index);
  }
  var active = isActive();
  useEffect(function () {
    clearTimeout(timeoutRef.current);
    if (active) {
      timeoutRef.current = setTimeout(function () {
        setRendered(true);
      }, duration);
    } else {
      setRendered(false);
    }
    return function () {
      clearTimeout(timeoutRef.current);
    };
  }, [active]);
  var finalClassName = classNames((_classNames = {
    'accordion-content': true
  }, _defineProperty(_classNames, className, true), _defineProperty(_classNames, "active", active), _defineProperty(_classNames, "rendered", rendered), _classNames));
  var AccordionContent = /*#__PURE__*/React.createElement(SemanticUiAccordion.Content, _extends({}, getAccordionContentProps(props), {
    active: active,
    index: index,
    className: finalClassName
  }), content || children);
  if (!duration) {
    return AccordionContent;
  }
  return /*#__PURE__*/React.createElement(AnimateHeight, {
    className: "animated-content",
    duration: duration,
    height: isActive() ? 'auto' : 0
  }, AccordionContent);
}
Content.defaultProps = defaultProps;
Content.displayName = ACCORDION_CONTENT_DISPLAY_NAME;